import { selectors } from 'modules/common';
import { domain } from 'modules/data';

export const checkIsAdministratorUserProfile = (profile: selectors.types.ExpandedProfile | null) => {
    return profile?.account?.userRole === domain.AccountMemberRole.Administrator;
};
